String.prototype.hashCode = function () {
  var hash = 0,
    i,
    chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const str = document.querySelector('.announcement-bar .announcement-bar__message span').textContent;

const announcements = document.querySelectorAll('.announcement-close');

announcements.forEach((announcement) => {
  announcement.addEventListener('click', () => {
    const announcementBar = announcement.closest('.m-ann');
    const announcementBarCont = announcement.closest('.announcement-bar-section');
    setCookie('montara-' + announcementBar.getAttribute('data-sha'), 'closed', 30);
    announcementBarCont.style.display = 'none';
  });
});

const announcementBar = document.querySelectorAll('.m-ann');
announcementBar.forEach((announcement) => {
  const announcementSha = announcement.getAttribute('data-sha');
  if (getCookie('montara-' + announcementSha) === 'closed') {
    announcement.style.display = 'none';
    document.querySelector('.announcement-bar-section').style.display = 'none';
  } else {
  }
  let aheight = document.querySelector('.announcement-bar-section').clientHeight;
  let sheight = document.querySelector('.section-header').clientHeight;
  if (document.querySelector('.montara-hero-section')) {
    document.querySelector('.montara-hero-section').style.minHeight = 'calc(100vh - ' + (aheight + sheight) + 'px)';
  }
  if (document.querySelector('.montara-hero')) {
    document.querySelector('.montara-hero').style.minHeight = 'calc(100vh - ' + (aheight + sheight) + 'px)';
  }
});
